import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { HiOutlineExclamation } from 'react-icons/hi';

export default function RequestDOIModal({ setOpenDOIModal, openDOIModal, requestDOI, project }) {
  const [doi, setDOI] = useState();

  return(
    <Transition.Root show={openDOIModal} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpenDOIModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-hidden">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6 dark:bg-gray-900">
                <div>
                  <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100 dark:bg-green-200">
                    <HiOutlineExclamation className="h-6 w-6 text-green-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900 dark:text-white">
                      Do you want to request a DOI?
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                        A Digital Object Identifier is an alphanumeric string used to uniquely identify digital information.
                      </p>
                      <p className="text-sm text-gray-500 mt-1.5 dark:text-gray-400">
                        Already have a DOI for this project? Enter it in the field below and we will add it to your project.
                      </p>
                      <div className='text-left mt-2'>
                        <label for="doi" className="text-sm text-gray-700 font-medium dark:text-white">DOI</label>
                        <div class="mt-2">
                          <input onChange={(e) => {setDOI(e.target.value)}} type="doi" name="doi" id="doi" class="block w-full rounded-md border py-1.5 px-1.5 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 dark:bg-gray-700 dark:text-white dark:border-gray-600" placeholder="10.21963/11896" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6">
                  <button
                    type="button"
                    className="mb-2 inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    data-cy="request-doi-accept"
                    onClick={() => {
                      setOpenDOIModal(false);
                      // Pass project id, title, and the user-entered DOI
                      requestDOI(project.id, project.title, doi);
                    }}
                  >
                    Request DOI
                  </button>
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-gray-700 bg-gray-300 hover:bg-gray-400 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 dark:border dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700 dark:hover:text-white dark:hover:bg-gray-700"
                    onClick={() => {setOpenDOIModal(false)}}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
